// Module
var code = "<div style=\"display:block\" class=\"mas-h-100\" ng-if=\"$ctrl.graphGran\"> <chart class=\"mas-h-100\" chart-id=\"{{$ctrl.uid}}\" chart-type=\"$ctrl.graphGran.type\" chart-labels=\"$ctrl.graphGran.data.labels\" chart-datasets=\"$ctrl.graphGran.data.datasets\" chart-options=\"$ctrl.graphGran.options\"/> </div> ";
// Exports
module.exports = code;